var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPromoInside(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-promo-inside_svg__Icon_-_Promo_Enclosed",
    "data-name": "Icon - Promo Enclosed",
    transform: "translate(-66.5 -529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-promo-inside_svg__Badge",
    transform: "translate(-35 401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-promo-inside_svg__Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(103.5 130)",
    fill: "#ffb100",
    stroke: "#2b3236",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 8,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "icon-promo-inside_svg__Path_5589",
    "data-name": "Path 5589",
    d: "M75.944 534.503l.967 2.086h1.882a.462.462 0 01.325.806l-1.631 1.608.905 2.08a.493.493 0 01-.7.617l-2.19-1.232-2.19 1.232a.493.493 0 01-.7-.617l.905-2.079-1.632-1.608a.461.461 0 01.321-.807h1.882l.967-2.086a.5.5 0 01.889 0z",
    fill: "none",
    stroke: "#2b3236",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0iSWNvbl8tX1Byb21vX0VuY2xvc2VkIiBkYXRhLW5hbWU9Ikljb24gLSBQcm9tbyBFbmNsb3NlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY2LjUgLTUyOSkiPgogICAgPGcgaWQ9IkJhZGdlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzUgNDAxKSI+CiAgICAgIDxnIGlkPSJFbGxpcHNlXzMiIGRhdGEtbmFtZT0iRWxsaXBzZSAzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDMuNSAxMzApIiBmaWxsPSIjZmZiMTAwIiBzdHJva2U9IiMyYjMyMzYiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgPGNpcmNsZSBjeD0iNyIgY3k9IjciIHI9IjciIHN0cm9rZT0ibm9uZSIvPgogICAgICAgIDxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI4IiBmaWxsPSJub25lIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJQYXRoXzU1ODkiIGRhdGEtbmFtZT0iUGF0aCA1NTg5IiBkPSJNOC4yMTUsNC4yN2wuOTY3LDIuMDg2aDEuODgyYS40NjIuNDYyLDAsMCwxLC4zMjUuODA2TDkuNzU4LDguNzdsLjkwNSwyLjA4YS40OTMuNDkzLDAsMCwxLS43LjYxN0w3Ljc3MywxMC4yMzVsLTIuMTksMS4yMzJhLjQ5My40OTMsMCwwLDEtLjctLjYxN2wuOTA1LTIuMDc5TDQuMTU2LDcuMTYzYS40NjEuNDYxLDAsMCwxLC4zMjEtLjgwN0g2LjM1OUw3LjMyNiw0LjI3YS41LjUsMCwwLDEsLjg4OSwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjcuNzI5IDUzMC4yMzMpIiBmaWxsPSJub25lIiBzdHJva2U9IiMyYjMyMzYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgIconPromoInside as ReactComponent };